import React from 'react';
import '../../../../static/styles/apiguide.scss';
import '../../../../static/styles/dashboard.scss';

export default class ViewTourItemInventoriesV2 extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
          <div>

              {/*<h3 className="mb0 mt40">2. 파라미터 값으로 여러 여러개의 여행상품을 가져오는 API.</h3>*/}
              <h3 className="mb0 mt40">재고 조회</h3>

              <div className="blog-post-meta">
                  <span className="s-post">등록한 상품의 재고 정보를 조회 할 수 있습니다.</span>
                  <h3 className="request-method">
                      <span className="label label-primary">GET</span>
                  </h3>
              </div>

              <div className="table-responsive">
                  <table className="table table-striped">
                      <tbody>
                          <tr>
                              <td>Path</td>
                              <td>Example Endpoint</td>
                          </tr>
                          <tr>
                              <td>/v2/marketplace/search/{'{travelProductId}'}/items/{'{travelItemId}'}/inventories</td>
                              <td>
                                  https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v2/marketplace/search/1234567890/items/11111111/inventories
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>

              <div className="table-responsive mt40">
                  <h4>Request Parameters</h4>
                  <table className="table table-striped">
                      <tbody>
                          <tr>
                              <th colSpan={col_number_8} className="bold">Request Header</th>
                          </tr>
                          <tr>
                              <th colSpan={level1}>Name</th>
                              <th>Required</th>
                              <th>Type</th>
                              <th>Description</th>
                          </tr>
                          <tr>
                              <td colSpan={level1}>Request-Vendor-Id</td>
                              <td>O</td>
                              <td>String</td>
                              <td>벤더 아이디</td>
                          </tr>
                          <tr>
                              <th colSpan="8" className="bold">Path Segment Parameter</th>
                          </tr>
                          <tr>
                              <th colSpan={level1}>Name</th>
                              <th>Required</th>
                              <th>Type</th>
                              <th>Description</th>
                          </tr>
                          <tr>
                              <td colSpan={level1}>travelProductId</td>
                              <td>O</td>
                              <td>Long</td>
                              <td>쿠팡 상품 아이디</td>
                          </tr>
                          <tr>
                              <td colSpan={level1}>travelItemId</td>
                              <td>O</td>
                              <td>Long</td>
                              <td>쿠팡 상품 아이템 아이디</td>
                          </tr>
                          <tr>
                              <th colSpan="8" className="bold"> Query Parameters</th>
                          </tr>
                          <tr>
                              <th colSpan={level1}>Name</th>
                              <th>Required</th>
                              <th>Type</th>
                              <th>Description</th>
                          </tr>
                          <tr>
                              <td colSpan={level1}>rateType</td>
                              <td>X</td>
                              <td>String</td>
                              <td>
                                  <table className="table table-striped">
                                      <tbody>
                                          <tr>
                                              <th>Optional Value</th>
                                              <th>Description</th>
                                          </tr>
                                          <tr>
                                              <td>ADULT</td>
                                              <td>성인</td>
                                          </tr>
                                          <tr>
                                              <td>CHILD</td>
                                              <td>아동</td>
                                          </tr>
                                          <tr>
                                              <td>TODDLER</td>
                                              <td>유아</td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </td>
                          </tr>
                          <tr>
                              <td colSpan={level1}>calendarDate</td>
                              <td>X</td>
                              <td>String</td>
                              <td>특정일자. Format: yyyy-MM-dd</td>
                          </tr>
                      </tbody>
                  </table>
              </div>

              <div className="table-responsive mt40">
                  <h4>Response Specifications</h4>
                  <table className="table table-striped">
                      <tbody>
                          <tr>
                              <td colSpan={level1}>code</td>
                              <td>String</td>
                              <td>응답 코드</td>
                          </tr>
                          <tr>
                              <td colSpan={level1}>message</td>
                              <td>String</td>
                              <td>응답 메세지</td>
                          </tr>
                          <tr>
                              <td colSpan={level1}>data</td>
                              <td>Array</td>
                              <td></td>
                          </tr>
                          <tr>
                              <td>&nbsp;</td>
                              <td colSpan={level2}>calendarDate</td>
                              <td>String</td>
                              <td>특정일자. Format: yyyy-MM-dd</td>
                          </tr>
                          <tr>
                              <td>&nbsp;</td>
                              <td colSpan={level2}>deadlineDay</td>
                              <td>Integer</td>
                              <td>사용하는 날짜전에 몇 일에 프로덕트 판매를 중지시키겠습니까? 기본값: 0</td>
                          </tr>
                          <tr>
                              <td>&nbsp;</td>
                              <td colSpan={level2}>deadlineHour</td>
                              <td>Integer</td>
                              <td>사용하는 날짜 마이너스 deadlineDay 전에 몇 시간에 프로덕트 판매를 중지시키겠습니까? 데이터는 1부터 24까지이며 디폴트값:24</td>
                          </tr>
                          <tr>
                              <td>&nbsp;</td>
                              <td colSpan={level2}>onSale</td>
                              <td>Boolean</td>
                              <td>판매 중:true, 판매중지:false</td>
                          </tr>
                          <tr>
                              <td>&nbsp;</td>
                              <td colSpan={level2}>rateType</td>
                              <td>String</td>
                              <td>요금타입</td>
                          </tr>
                          <tr>
                              <td>&nbsp;</td>
                              <td colSpan={level2}>salePrice</td>
                              <td>Integer</td>
                              <td>판매가</td>
                          </tr>
                          <tr>
                              <td>&nbsp;</td>
                              <td colSpan={level2}>totalSoldCount</td>
                              <td>String</td>
                              <td>총판매수</td>
                          </tr>
                          <tr>
                              <td>&nbsp;</td>
                              <td colSpan={level2}>totalStockCount</td>
                              <td>String</td>
                              <td>총 재고 수량</td>
                          </tr>
                      </tbody>
                  </table>
              </div>

              <div className="table-responsive mt40">
                  <div className="panel panel-default">
                      <div className="panel-heading">
                          {/*<h3 className="panel-title">응답값 예시</h3>*/}
                          <a data-toggle="collapse" href = "#toursResponseDto">Response Body Sample</a>
                      </div>
                      <div id = "toursResponseDto" className = "panel-collapse collapse">
                          <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "OK",
    "nextPageToken": "1573106534426",
    "size": 20,
    "data": [
        {
            "travelProductId": 515006525668851712,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-22T11:32:13.55",
            "modifiedAt": "2019-11-22T11:32:15.449"
        },
        {
            "travelProductId": 511520339147096064,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T21:13:46.422",
            "modifiedAt": "2019-11-13T07:52:14.463"
        },
        {
            "travelProductId": 511496123001602048,
            "sellerProductId": "seller-product-id",
            "vendorItemPackageId": 0,
            "productId": 0,
            "travelType": "OVERSEAS",
            "productDetailType": "PACKAGE_TOUR",
            "vendorId": "A0000TEST",
            "qcStatus": null,
            "saleStatus": null,
            "name": "[장가계]★BSET★효도여행 추천 4/5일 패키지",
            "createdAt": "2019-11-12T19:03:08.745",
            "modifiedAt": "2019-11-12T19:09:53.528"
        }
    ]
}
                        `}

                    </pre>
                          </div>
                      </div>
                  </div>
              </div>

              <div className="table-responsive">
                  <table className="table table-striped">
                      <tbody>
                          <tr>
                              <th>HTTP CODE</th>
                              <th>message</th>
                              <th>설명</th>
                          </tr>
                          <tr>
                              <td>400</td>
                              <td>Bad request</td>
                              <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다</td>
                          </tr>
                          <tr>
                              <td>401</td>
                              <td>Unauthorized Error</td>
                              <td>잘못된 인증 정보</td>
                          </tr>
                          <tr>
                              <td>403</td>
                              <td>Forbidden Error</td>
                              <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                          </tr>
                          <tr>
                              <td>410</td>
                              <td>The resource has been permanently deleted</td>
                              <td>리소스가 삭제되었을 경우 발생합니다</td>
                          </tr>
                          <tr>
                              <td>412</td>
                              <td>Precondition failed</td>
                              <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                          </tr>
                          <tr>
                              <td>429</td>
                              <td>Too many requests</td>
                              <td>요청이 많을 경우 발생합니다</td>
                          </tr>
                          <tr>
                              <td>504</td>
                              <td>API Gateway response timeout</td>
                              <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                          </tr>
                          <tr>
                              <td>521</td>
                              <td>API provider server has error</td>
                              <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                          </tr>
                          <tr>
                              <td>524</td>
                              <td>API provider to API gateway connection response timeout</td>
                              <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TourAPIContent/V2/ProductAPI/ViewTourItemInventoriesV2.jsx